<template style="height: 100%;">
  <div class="Useraddsingle">
    <h2>新增用户</h2>

    <div class="basic">
      <div class="tit">
        <span></span>
        <p>基本信息</p>
      </div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="用户类型" prop="RoleID">
          <el-select v-model="ruleForm.RoleID" placeholder="请选择" @change="RoleIDTypeSelect()">
            <el-option-group v-for="group in opt" :key="group.key" :label="group.value">
              <el-option v-for="item in group.RoleList" :key="item.key" :label="item.value" :value="item.key"></el-option>
            </el-option-group>
          </el-select>
        </el-form-item>

        <el-form-item :label="!this.ruleForm.RoleIDType ? $t('original.account') : '工号'" prop="UserID">
          <el-input v-model="ruleForm.UserID"></el-input>
        </el-form-item>

        <el-form-item label="姓名" prop="RealName">
          <el-input v-model="ruleForm.RealName"></el-input>
        </el-form-item>

        <el-form-item label="身份证号" prop="IDCard" v-if="!this.ruleForm.RoleIDType">
          <el-input v-model="ruleForm.IDCard"></el-input>
        </el-form-item>

        <el-form-item label="性别" prop="Sex" v-if="!this.ruleForm.RoleIDType">
          <el-radio v-model="ruleForm.Sex" label="1">男</el-radio>
          <el-radio v-model="ruleForm.Sex" label="0">女</el-radio>
        </el-form-item>

        <el-form-item label="出生日期" prop="Birthday" v-if="!this.ruleForm.RoleIDType">
          <el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="ruleForm.Birthday"
            :picker-options="pickerOptions"></el-date-picker>
        </el-form-item>

        <el-form-item label="个人号码" prop="Phone">
          <el-input v-model="ruleForm.Phone"></el-input>
        </el-form-item>

        <el-form-item label="所属单位" prop="DeptID">
          <div class="block">
            <el-cascader ref="wcascader" @change="Selected_to_shut_dow" @expand-change="bumen" :options="data"
              :props="{ checkStrictly: true }" clearable></el-cascader>
          </div>
        </el-form-item>

        <el-form-item label="入学年份" prop="TheEntranceDate">
          <el-select v-model="ruleForm.TheEntranceDate" placeholder="请选择入学年份">
            <el-option :label="item" :value="item" v-for="(item, index) in YearList" v-bind:key="index"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="年级" prop="EntryDate" v-if="!this.ruleForm.RoleIDType">
          <el-select v-model="ruleForm.EntryDate" placeholder="请选择年级">
            <el-option :label="item.CDicValue" :value="item.CDicValue" v-for="(item, index) in GradeList"
              v-bind:key="index"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="监护人姓名" prop="TheGuardian" v-if="!this.ruleForm.RoleIDType">
          <el-input v-model="ruleForm.TheGuardian"></el-input>
        </el-form-item>

        <el-form-item label="监护人电话" prop="TheGuardianPhone" v-if="!this.ruleForm.RoleIDType">
          <el-input v-model="ruleForm.TheGuardianPhone"></el-input>
        </el-form-item>

        <el-form-item label="监护人身份" prop="TheGuardianRelationShip" v-if="!this.ruleForm.RoleIDType">
          <el-select v-model="ruleForm.TheGuardianRelationShip" placeholder="请选择监护人身份">
            <el-option :label="item.CDicValue" :value="item.CDicValue" v-for="(item, index) in RelativeList"
              v-bind:key="index"></el-option>
          </el-select>
          <el-input v-model="ruleForm.Bak19" maxlength="20" v-if="ruleForm.TheGuardianRelationShip == '其他'"></el-input>
        </el-form-item>

        <el-form-item label="学生类型" prop="NativePlace" v-if="!this.ruleForm.RoleIDType">
          <el-select v-model="ruleForm.Degree" placeholder="请选择学生类型">
            <el-option :label="item.CDicValue" :value="item.CDicValue" v-for="(item, index) in DegreeList"
              v-bind:key="index"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="民族" prop="Nation" v-if="!this.ruleForm.RoleIDType">
          <el-select v-model="ruleForm.Nation" placeholder="请选择民族">
            <el-option :label="item.CDicValue" :value="item.DicKey" v-for="(item, index) in NationList"
              v-bind:key="index"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="国籍" prop="Nationality" v-if="!this.ruleForm.RoleIDType">
          <el-select v-model="ruleForm.Nationality" placeholder="请选择国籍">
            <el-option :label="item.CDicValue" :value="item.DicKey" v-for="(item, index) in NationalityList"
              v-bind:key="index"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="学籍异动" prop="Nation" v-if="!this.ruleForm.RoleIDType">
          <el-select v-model="ruleForm.Bak18" placeholder="请选择学籍异动">
            <el-option :label="item.CDicValue" :value="item.CDicValue" v-for="(item, index) in StudentList"
              v-bind:key="index"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="备注" prop="SchoolRemark">
          <el-input v-model="ruleForm.SchoolRemark"></el-input>
        </el-form-item>

        <el-form-item label="序号" prop="LineNumber" v-if="!this.ruleForm.RoleIDType">
          <el-input-number v-model="ruleForm.LineNumber" controls-position="right" :min="1" :max="10000000">
          </el-input-number>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">
            立即创建
          </el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      msgFormSon: 'this is msg',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 3600 * 1000 * 24 + 8.64e7;
        },
      },
      value: '',
      ruleForm: {
        IndividualResume: '',
        VideoAccount: '',
        RealName: '',
        LineNumber: '',
        RoleID: '',
        UserID: '',
        Sex: '1',
        Birthday: '',
        DeptID: '',
        Phone: '',
        IDCard: '',
        AccountType: '1',
        CaseContent: '',
        ClinicDate: '',
        ClinicType: '',
        CaseRemark: '',
        Class: '',
        TheEntranceDate: '',
        TheGuardian: '',
        NativePlace: '',
        SchoolRemark: '',
        Nation: '',
        TheGuardianPhone: '',
        EntryDate: '',
        CaseRemark: '',
        RoleIDType: true,
      },
      opt: '',
      values: '',
      rules: {
        Phone: [
          {
            required: true,
            pattern: /^1[3456789]\d{9}$/,
            message: '请输入正确的手机号',
            trigger: 'blur',
          },
        ],

        IDCard: [
          {
            required: true,
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: '请输入正确的身份证号',
            trigger: 'blur',
          },
        ],
        RealName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        RoleID: [
          { required: true, message: '请选择用户类型', trigger: 'blur' },
        ],
        DeptID: [
          { required: true, message: '请选择单位名称', trigger: 'blur' },
        ],
        UserID: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        Sex: [{ required: true, message: '请选择性别', trigger: 'blur' }],
        Birthday: [
          { required: true, message: '请选择出生日期', trigger: 'blur' },
        ],
        AccountType: [
          { required: true, message: '请选择户口类型', trigger: 'blur' },
        ]
      },
      data: [],
      option: [],
      YearList: [],
      GradeList: [],
      RelativeList: [],
      DegreeList: [],
      NationList: [],
      NationalityList: [],
      StudentList: [],
    };
  },
  methods: {
    Selected_to_shut_dow(dt) {
      this.ruleForm.DeptID = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },
    RoleIDTypeSelect() {
      if (this.ruleForm.RoleID == '') {
        this.ruleForm.RoleIDType = true;
      } else {
        if (this.ruleForm.RoleID == '1058') {
          this.ruleForm.RoleIDType = false;
        }
        else this.ruleForm.RoleIDType = true;
      }
    },
    getMsgFormSon(data) {
      this.msgFormSon = data;
    },
    submitForm(formName) {
      if (this.ruleForm.UserID == '') {
        this.Global.request_info('请填写学号');
      } else if (this.ruleForm.RealName == '') {
        this.Global.request_info('请填写姓名');
      } else if (this.ruleForm.RealName == '') {
        this.Global.request_failure('请输入姓名');
      } else if (!this.ruleForm.RoleIDType && this.ruleForm.IDCard == '') {
        this.Global.request_failure('请输入身份证号');
      } else if (!this.ruleForm.RoleIDType && this.ruleForm.Sex == undefined || this.ruleForm.Sex == '') {
        this.Global.request_info('请选择性别');
      } else if (!this.ruleForm.RoleIDType && (
        this.ruleForm.Birthday == undefined ||
        this.ruleForm.Birthday == '')
      ) {
        this.Global.request_info('请填写出生日期');
      } else if (
        this.ruleForm.Phone == undefined ||
        this.ruleForm.Phone == ''
      ) {
        this.Global.request_info('请填写个人电话号码');
      } else if (!this.ruleForm.RoleIDType && (
        this.ruleForm.DeptID == undefined ||
        this.ruleForm.DeptID == '')
      ) {
        this.Global.request_info('请选择单位');
      } else {
        let _this = this;
        if (this.CheckSumDataState()) {
          for (let i = 0; i < _this.RelativeList.length; i++) {
            if (
              _this.RelativeList[i].CDicValue ==
              _this.ruleForm.TheGuardianRelationShip
            ) {
              _this.ruleForm.TheGuardianRelationShip =
                _this.RelativeList[i].DicKey;
              break;
            }
          }
          this.$Http_Post('ReportCriData/AddUserInfo', _this.ruleForm)
            .then((res) => {
              if (res.Code == 200 || res.Code == 0) {
                this.Global.request_successful('保存成功！');
                setTimeout((result) => {
                  _this.dialogVisible = false;
                  _this.ruleForm = {
                    UserID: '',
                    RealName: '',
                    UserTime: null,
                  };
                }, 2000);
              } else {
                this.Global.request_failure(res.Message);
              }
            })
            .catch((err) => {
              this.$message({
                type: 'error',
                message: err.message,
              });
            });
        }
      }
    },
    CheckSumDataState() {
      let result = true;
      if (this.ruleForm.UserID == '') {
        result = false;
        this.Global.request_failure('请输入学号');
      } else if (this.ruleForm.RealName == '') {
        result = false;
        this.Global.request_failure('请输入姓名');
      } else if (!this.ruleForm.RoleIDType && (
        this.ruleForm.IDCard == undefined ||
        this.ruleForm.IDCard == '')
      ) {
        result = false;
        this.Global.request_failure('请输入身份证号');
      } else if (!this.ruleForm.RoleIDType && !this.Global.isCardID(this.ruleForm.IDCard)) {
        result = false;
        this.Global.request_failure('身份证格式错误');
      } else if (
        this.ruleForm.Phone != undefined &&
        this.ruleForm.Phone != '' &&
        !this.Global.checkMobile(this.ruleForm.Phone)
      ) {
        result = false;
        this.Global.request_failure('个人电话号码格式错误');
      }
      return result;
    },
    // 滚动条定位到第一个校验失败的div的位置
    locateToErr() {
      setTimeout(() => {
        const errorDiv = document.getElementsByClassName('is-error');
        errorDiv[0].scrollIntoView();
      }, 0);
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    GetNodeByDeptID(ID, NodeList) {
      let obj = null;
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].DeptID == ID) {
          obj = NodeList[i];
          break;
        } else if (
          NodeList[i].fuzi &&
          NodeList[i].children.length > 0 &&
          NodeList[i].children[0].DeptID != '-1'
        ) {
          obj = this.GetNodeByDeptID(ID, NodeList[i].children);
          if (obj != null) break
        }
      }
      return obj;
    },
    bumen(dt) {
      let obj = this.data[0];
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].DeptID == dt[dt.length - 1]) {
          obj = this.data[i];
          break;
        } else if (
          this.data[i].fuzi &&
          this.data[i].children.length > 0 &&
          this.data[i].children[0].DeptID != '-1'
        ) {
          obj = this.GetNodeByDeptID(dt[dt.length - 1], this.data[i].children);
        }
      }

      let _this = this;
      if (
        obj.fuzi &&
        obj.children.length > 0 &&
        obj.children[0].DeptID == '-1'
      ) {
        obj.children = [{ label: '数据加载中...' }];
        this.$Http_Post('/DepartMent/GetDeprtMentByNode', {
          DeptID: dt[dt.length - 1],
          content: '',
        }).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data;
          }
        });
      }
    },
  },

  mounted() {
    let nowYear = new Date().getFullYear();
    for (let i = 0; i < 10; i++) {
      this.YearList.push(nowYear - i);
    }
    this.$Http_Post('/DepartMent/GetDeprtMentByNode', {
      DeptID: '',
      content: '',
    }).then((res) => {
      if (res.Code == 200 || res.Code == 0 && res.Data) {
        this.data = res.Data;
      }
    });
    let _this = this
    this.$Http_Post('User/GetDicListByDicTypeCode', {
      DicTypeList: 'GradeLevel,Degree,Nation,Nationality,Relative,Student',
    })
      .then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          _this.GradeList = res.Data[0];
          _this.DegreeList = res.Data[1];
          _this.NationList = res.Data[2];
          _this.NationalityList = res.Data[3];
          _this.RelativeList = res.Data[4];
          _this.StudentList = res.Data[5];
        } else {
          this.Global.request_failure(res.Message);
        }
      })
      .catch((err) => {
        this.Global.request_failure(err.Message);
      });
    this.$Http_Post('User/DictionaryList')
      .then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.value = res.Data;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
      .catch((err) => {
        this.$message({
          type: 'error',
          message: err.message,
        });
      });

    this.$Http_Post('User/GetUserType')
      .then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.opt = res.Data;
        }
      })
      .catch((err) => {
        this.$message({
          type: 'error',
          message: err.message,
        });
      });
  },
};
</script>
<style>
.Useraddsingle {
  height: 100%;
  overflow: auto;
}

.Useraddsingle .el-form-item {
  margin-bottom: 0px;
  width: 400px;
}

.Useraddsingle .el-form-item__content {
  margin-bottom: 20px;
}

.Useraddsingle>h2 {
  font-size: 16px;
}

.Useraddsingle .basic {
  width: 320px;
  margin-left: -20px;
}

.Useraddsingle .tit span {
  width: 3px;
  height: 20px;
  background-color: rgba(0, 136, 255, 1);
  display: inline-block;
  position: absolute;
  left: 0px;
  top: 0px;
}

.Useraddsingle .tit p {
  position: absolute;
  left: 10px;
  top: 0px;
}

.Useraddsingle .tit {
  position: relative;
  margin-top: 16px;
  height: 30px;
  margin-left: 20px;
}

.Useraddsingle .el-textarea textarea {
  height: 80px;
}

.Useraddsingle .el-form {
  margin-left: 20px;
  width: 900px;
}

.Useraddsingle .el-date-editor.el-input,
.Useraddsingle .el-date-editor.el-input__inner {
  width: 100%;
}

.Useraddsingle .el-cascader {
  width: 100%;
}

.Useraddsingle .el-select {
  width: 100%;
}

.Useraddsingle .el-textarea .el-input__count {
  height: 20px;
  bottom: 12px;
}
</style>
